<template>
  <div>
    <h1 v-if="showTitle" class="my-5 text-center">{{ titleContext }}</h1>
    <input-form-custom
      name="user.second_name"
      v-model="user.second_name"
      label="Фамилия"
    />
    <input-form-custom
      name="user.first_name"
      v-model="user.first_name"
      label="Имя"
    />
    <input-form-custom
      v-if="showThirdName"
      name="user.third_name"
      v-model="user.third_name"
      label="Отчество"
    />
    <input-form-custom
      name="user.email"
      v-model="user.email"
      label="Электронная почта (логин)"
      rule="required|email"
      :disabled="disableEmail"
    />
    <input-form-custom
      v-if="showPhone"
      name="user.phone"
      v-model="user.phone"
      label="Телефон"
      :rule="{ required: true, regex: /^\+[1-9]{1}[0-9]{10}$/ }"
    />
  </div>
</template>

<script>
  export default {
    inject: {
      $validator: '$validator'
    },
    props: {
      value: {
        type: Object,
        default: () => ({}), 
      },
      disableEmail: {
        type: Boolean,
        default: false, 
      },
      showThirdName: {
        type: Boolean,
        default: true,
      },
      showPhone: {
        type: Boolean,
        default: true,
      },
      showTitle: {
        type: Boolean,
        default: true,
      },
      titleContext: {
        type: String,
        default: "Информация пользователя", 
      },
    },
    data () {
      return {
        user: this.value ? this.value : {},
      }
    },
    watch: {
      user () {
        this.$emit('input', this.user)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/personal/user.vue